/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_One_Drive_SearchInputs */

const es_tools_one_drive_search = /** @type {(inputs: Tools_One_Drive_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en OneDrive...`)
};

const en_tools_one_drive_search = /** @type {(inputs: Tools_One_Drive_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching OneDrive...`)
};

/**
* | output |
* | --- |
* | "Searching OneDrive..." |
*
* @param {Tools_One_Drive_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_one_drive_search = /** @type {((inputs?: Tools_One_Drive_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_One_Drive_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_one_drive_search(inputs)
	return en_tools_one_drive_search(inputs)
});
export { tools_one_drive_search as "tools.one_drive.search" }